import { toaster } from "../../components/ui/toaster";



export type ToastStatus = "success" | "error" | "warning" | "info" | "loading";

const useToast = () => {
    const duration = (status: ToastStatus) => {
        switch (status) {
            case "success":
                return 5000;
            case "loading":
                return 1_000_000_000;
            case "error":
                return 1_000_000_000;
            case "warning":
                return 10_000;
            case "info":
                return 5000;
        }
    };

    const toastFunction = (title: string, description: string, status: ToastStatus = "info") => {
        const toast = toaster.create({
            title,
            description,
            type: status,
            duration: duration(status),
            meta: {
                closable: status !== "loading",
            },
        });

        return () => toaster.dismiss(toast);
    };

    return toastFunction;
};

export default useToast;



